import { SxProps } from "@mui/system";
import {
  selectMultiSelectRankContainerStyle,
  selectMultiSelectRankBorder,
  choiceGroupHeadingStyle,
} from "../../components/ui/CommonStyles/commonStyle";
import type { ThemeV2 } from "../../util/types";

export const containerStyle = (isLandScapeMode: boolean): SxProps => ({
  marginTop: isLandScapeMode ? null : "8px",
  display: "flex",
  width: "100%",
});

export const buttonWrapper = (
  isLandScapeMode: boolean,
  theme: ThemeV2,
  isStyleList: boolean,
): SxProps => ({
  display: "flex",
  flexWrap: "wrap",
  flex: 1,
  width: "100%",
  ...(isStyleList
    ? {
        ...selectMultiSelectRankBorder(
          isLandScapeMode,
          theme.tokens.color.action.primary,
          theme.tokens.color.surface.card,
          theme.tokens.shape.radius.md,
          {
            margin: 2,
          },
        ),
        justifyContent: "start",
        flexDirection: "column",
        alignItems: "self-start",
      }
    : selectMultiSelectRankContainerStyle(isLandScapeMode)),

  padding: `${theme.tokens.spacing["4"]}px`,
  ...choiceGroupHeadingStyle(isLandScapeMode, isStyleList, theme),
});
